<div  class="pages-result__img-col">
	<div class="pages-result__icon">
		<span class="icon-link"></span>
	</div>
</div>
